{
  "nameInput": {
    "placeholder": "ما اسمك؟"
  },
  "signIn": {
    "tagline": "ابدأ بالنيّة.",
    "signingIn": "جارٍ تسجيل الدخول…",
    "continueApple": "المتابعة باستخدام Apple",
    "continueApple_aria": "المتابعة باستخدام Apple",
    "continueGoogle": "المتابعة باستخدام Google",
    "continueGoogle_aria": "المتابعة باستخدام Google",
    "logo_alt": "Rhemn",
    "footer": "بتسجيل الدخول، فإنك توافق على شروط الخدمة و<privacyLink>سياسة الخصوصية</privacyLink>.",
    "divider": "أو"
  },
  "email": {
    "identity": {
      "label": "عنوان البريد الإلكتروني",
      "placeholder": "you@example.com",
      "change": "تغيير",
      "change_aria": "تغيير عنوان البريد الإلكتروني"
    },
    "password": {
      "label": "كلمة المرور",
      "labelNew": "اختر كلمة مرور",
      "placeholder": "كلمة المرور",
      "placeholderNew": "أنشئ كلمة مرور",
      "show": "إظهار كلمة المرور",
      "hide": "إخفاء كلمة المرور"
    },
    "actions": {
      "continue": "متابعة",
      "signIn": "تسجيل الدخول",
      "createAccount": "إنشاء حساب",
      "forgot": "نسيت كلمة المرور؟",
      "backToSignIn": "العودة إلى تسجيل الدخول",
      "iVerified": "لقد تحققت من بريدي",
      "resend": "إعادة إرسال الرابط",
      "resendIn": "إعادة الإرسال خلال {{time}}",
      "signInInstead": "تسجيل الدخول"
    },
    "busy": {
      "checking": "جارٍ التحقق…",
      "signingIn": "جارٍ تسجيل الدخول…",
      "creating": "جارٍ إنشاء حسابك…",
      "sending": "جارٍ الإرسال…"
    },
    "switch": {
      "toCreate": "جديد في Rhemn؟ <switchBtn>أنشئ حسابًا</switchBtn>",
      "toSignIn": "لديك حساب بالفعل؟ <switchBtn>سجّل الدخول</switchBtn>"
    },
    "strength": {
      "tooShort": "12 حرفًا على الأقل.",
      "level1": "جيد. كلما طالت كانت أقوى.",
      "level2": "كلمة مرور قوية.",
      "level3": "كلمة مرور قوية جدًا."
    },
    "sent": {
      "title": "تحقق من بريدك",
      "body": "أرسلنا رابط إعادة التعيين إلى {{email}}. تنتهي صلاحيته خلال ساعة.",
      "resent": "تم الإرسال مرة أخرى. تحقق من بريدك."
    },
    "verify": {
      "title": "أكّد بريدك الإلكتروني",
      "body": "أرسلنا رابطًا إلى {{email}}. افتحه لإكمال إعداد حسابك — وسنتابع تلقائيًا من هناك.",
      "waiting": "في انتظار فتحك للرابط…",
      "resent": "تم الإرسال مرة أخرى. تحقق من بريدك."
    },
    "errors": {
      "invalidEmail": "لا يبدو هذا عنوان بريد إلكتروني.",
      "missingPassword": "أدخل كلمة المرور.",
      "invalidCredential": "البريد الإلكتروني أو كلمة المرور غير صحيحة.",
      "emailInUse": "هذا البريد له حساب بالفعل. <signInBtn>سجّل الدخول.</signInBtn>",
      "weakPassword": "استخدم 12 حرفًا على الأقل.",
      "passwordTooShort": "استخدم 12 حرفًا على الأقل.",
      "passwordCommon": "يسهل تخمين كلمة المرور هذه. جرّب شيئًا أقل توقعًا.",
      "emailNotVerified": "أكّد بريدك الإلكتروني قبل المتابعة.",
      "providerGoogle": "هذا البريد مُعدّ بالفعل مع Google. تابع باستخدام Google أدناه.",
      "providerApple": "هذا البريد مُعدّ بالفعل مع Apple. تابع باستخدام Apple أدناه.",
      "userDisabled": "تم تعطيل هذا الحساب.",
      "requiresRecentLogin": "سجّل الدخول مرة أخرى لإجراء هذا التغيير.",
      "sessionExpired": "انتهت جلستك. سجّل الدخول مرة أخرى.",
      "expiredActionCode": "انتهت صلاحية هذا الرابط. اطلب رابطًا جديدًا.",
      "invalidActionCode": "لم يعد هذا الرابط صالحًا. اطلب رابطًا جديدًا.",
      "tooManyRequests": "محاولات كثيرة. انتظر بضع دقائق أو أعد تعيين كلمة المرور.",
      "network": "لا يوجد اتصال. تحقق من شبكتك وحاول مرة أخرى.",
      "operationNotAllowed": "تسجيل الدخول بالبريد غير متاح حاليًا.",
      "generic": "حدث خطأ ما. يرجى المحاولة مرة أخرى."
    },
    "a11y": {
      "stepEmail": "الخطوة 1 من 2. أدخل عنوان بريدك الإلكتروني.",
      "stepPasswordSignIn": "الخطوة 2 من 2. أدخل كلمة المرور لتسجيل الدخول.",
      "stepPasswordCreate": "الخطوة 2 من 2. اختر كلمة مرور لحسابك الجديد.",
      "stepSent": "تم إرسال رابط إعادة التعيين. تحقق من بريدك.",
      "stepVerify": "تم إنشاء الحساب. تم إرسال رابط التحقق.",
      "resendReady": "يمكنك إعادة إرسال الرابط الآن."
    }
  }
}
